export default __webpack_public_path__ + "static/media/cert-finance-cpttm-sc.7400238d.jpg";